import styled from 'styled-components';
import { Link } from 'react-router-dom';

/* Menu lateral do Figma: fundo escuro da barra, item ativo em laranja. A
 * largura é a mesma do recuo do conteúdo no `ClientLayout`. */
export const SIDEBAR_WIDTH = 220;

export const SidebarContainer = styled.nav`
  position: fixed;
  z-index: 98;
  top: 64px;
  left: 0;
  width: ${SIDEBAR_WIDTH}px;
  height: calc(100vh - 64px);
  /* Visível para o submenu sair para o lado; só rola em janela muito baixa. */
  overflow: visible;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: ${(props) => props.theme.color.bg.secondary};

  @media only screen and (max-height: 420px) {
    overflow-y: auto;
  }

  @media only screen and (max-width: 950px) {
    display: none;
  }

  @media print {
    display: none;
  }
`;

/* Submenu do Figma ("Geral → Menu"): abre ao lado com o mouse ou com o foco do
 * teclado. O recuo transparente liga o item à caixa, senão o mouse sairia do
 * item ao atravessar o vão e o submenu fecharia. */
export const SubMenu = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  padding-left: 12px;
`;

export const SubMenuBox = styled.div`
  min-width: 140px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-radius: 3px;
  background-color: ${(props) => props.theme.color.bg.secondary};
  box-shadow: 0 8px 12px rgba(52, 87, 140, 0.12); /* Shadow/4 do Figma */
`;

export const SidebarItem = styled.div`
  position: relative;

  &:hover ${SubMenu}, &:focus-within ${SubMenu} {
    display: block;
  }
`;

export const SidebarLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  border-radius: 3px;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  color: ${(props) => props.theme.color.text.inverse};
  text-decoration: none;

  svg {
    flex-shrink: 0;
    font-size: 16px;
  }

  &:hover {
    color: ${(props) => props.theme.color.text.inverse};
    background: rgba(255, 255, 255, 0.08);
  }

  &.active {
    font-weight: ${(props) => props.theme.font.body.weight.bold};
    background: ${(props) => props.theme.color.ui.primary};
  }
`;

export const SubMenuLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 3px;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  color: ${(props) => props.theme.color.text.inverse};
  text-decoration: none;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
    font-size: 14px;
  }

  &:hover {
    color: ${(props) => props.theme.color.text.inverse};
    background: rgba(255, 255, 255, 0.08);
  }
`;
